<div class="content">
  <article>
    <table mat-table
           [dataSource]="dataSource"
           id="enrichment-credit-history-table"
           class="table-striped"
           matSort
           [ngClass]="{'no-tasks': dataSource.data.length === 0}">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date & time</th>
        <td mat-cell *matCellDef="let row">{{row.date | date:'medium'}}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction</th>
        <td mat-cell *matCellDef="let row">{{row.typeLabel}}</td>
      </ng-container>
      <ng-container matColumnDef="ruleName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rule name</th>
        <td class="green" mat-cell *matCellDef="let row">
          @if (row.ruleName) {
            <span class="rule-name-link"
                  role="button"
                  [attr.aria-label]="'Go to rule ' + row.ruleName"
                  tabindex="0"
                  (click)="goToRule(row.entity, row.ruleId)"
                  (keydown.enter)="goToRule(row.entity, row.ruleId)"
                  (keydown.space)="goToRule(row.entity, row.ruleId)"
                  matTooltip="Navigate to {{row.ruleName}}" [matTooltipShowDelay]="500">{{row.ruleName}}</span>
          } @else {
            -
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="entity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Entity</th>
        <td mat-cell *matCellDef="let row">{{row.entity}}</td>
      </ng-container>
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
        <td mat-cell *matCellDef="let row">{{row.userId}}</td>
      </ng-container>
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User name</th>
        <td mat-cell *matCellDef="let row">{{row.userName}}</td>
      </ng-container>
      <ng-container matColumnDef="recordCount">
        <th mat-header-cell class="grey-header" *matHeaderCellDef mat-sort-header>Record count</th>
        <td mat-cell *matCellDef="let row">{{row.recordCount}}</td>
      </ng-container>
      <ng-container matColumnDef="credits">
        <th mat-header-cell class="grey-header" *matHeaderCellDef mat-sort-header>Credits</th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'green': row.credits > 0, 'red': row.credits < 0}">
          {{row.credits > 0 ? '+' : ''}}{{row.credits.toLocaleString()}}
        </td>
      </ng-container>
      <ng-container matColumnDef="balance">
        <th mat-header-cell class="grey-header" *matHeaderCellDef mat-sort-header>Balance after</th>
        <td mat-cell *matCellDef="let row">{{row.balance.toLocaleString()}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row" [ngClass]="{'top-up-row': row.isTopup}"></tr>
    </table>
    <app-skeleton *ngIf="loading" [style]="'big-row-table'" [count]="5"></app-skeleton>
    <div *ngIf="dataSource.data.length === 0 && !loading" class="no-results">
      No credit transactions yet
    </div>
    <mat-paginator [pageSize]="10"
                   [pageSizeOptions]="pageSizeOptions"
                   [selectConfig]="pageSizeSelectConfig"
                   aria-label="Select page">
    </mat-paginator>
  </article>
</div>
